import React from 'react';

const Close = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 13 13"
    fill="currentColor"
    {...props}
  >
    <path d="M7.58 6.5l5.2-5.19a.79.79 0 000-1.09.79.79 0 00-1.09 0L6.5 5.42 1.31.22a.79.79 0 00-1.09 0 .79.79 0 000 1.09l5.2 5.19-5.2 5.19a.79.79 0 000 1.09.77.77 0 00.55.22.76.76 0 00.54-.22l5.19-5.2 5.19 5.2a.79.79 0 001.09 0 .79.79 0 000-1.09z" />
  </svg>
);

export default Close;
